import { FC, PropsWithChildren } from "react";

import { ImageNavLinksList as UIImageNavLinksList } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/ImageNavLinksList";

export const ImageNavLinksList: FC<PropsWithChildren> = (props) => {
  return <UIImageNavLinksList {...props} />;
};
